<div class="vertical">
  <h3>{{ fullname() }}</h3>
  <span>{{ login() }}</span>
</div>
<button
  (click)="open = !open"
  tuiButton
  [tuiDropdown]="dropdownProfileMenu"
  [tuiDropdownManual]="open"
  [tuiDropdownOffset]="0"
  tuiDropdownLimitWidth="fixed"
  tuiDropdownAlign="center"
  (tuiActiveZoneChange)="onActiveZone($event)"
  (tuiObscured)="onObscured($event)"
  class="user-info__profile-button"
>
  <tui-avatar [src]="icon()"/>
</button>

<ng-template #dropdownProfileMenu>
  <div class="user-profile-dropdown">
    <button
      (click)="logOut()"
      tuiButton
      class="user-profile-dropdown__exit-button"
    >
      <span class="user-profile-dropdown__exit-button-text">Выход</span>
    </button>
  </div>
</ng-template>
